export default () => ({
  modules: [],
});
